import addressAutofill from '../modules/addressCollapsibleAutofill';

const addressCollapsible = () => {
  addressAutofill();
};

export default addressCollapsible;
